import { useCallback } from 'react';
import { forEach } from 'lodash';
import { useLocation } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import { setCategoryRecords } from '../../data-layer/categories/actions';
import { setCollectionsRecords } from '../../data-layer/collections/actions';
import { CollectionModel } from '../../data-layer/collections/types';
import { showNotificationAsync } from '../../data-layer/notifications/actions';
import { addPostToBookmarkCollections, setPostRecords } from '../../data-layer/posts/actions';
import { COLLECTIONS_NAMESPACE_PREFIX } from '../../data-layer/posts/reducer';
import * as postsService from '../../data-layer/posts/service';
import { useDispatch } from '../../data-layer/useDispatch';
import { AddPostDrawer } from '../../ui/collection/AddPostDrawer';
import { PostUI } from '../../ui/posts/types';
import { useBackButton } from '../../utils/useBackButton';

const toProductPost = (post: PostUI, collectionId: CollectionModel['id']) => ({
    post_id: post.id,
    collection_id: collectionId,
    media: post.content.map((media) => ({
        id: media.id,
        type: media.type,
    })),
});

interface AddPostDialogState {
    collectionId: CollectionModel['id'];
}

export const AddPostDialog = () => {
    const state = useLocation().state as AddPostDialogState;
    const { collectionId } = state;
    const dispatch = useDispatch();
    const onNavigateBack = useBackButton();

    const [{ error: productLoadingError, loading: productLoading, value: newPost }, searchProduct] =
        useAsyncFn(async (productLink) => await postsService.searchPostByUrl(productLink), []);

    const savePostToCollection = useCallback(
        async (post: PostUI) => {
            try {
                const response = await postsService.savePostAsProduct(
                    toProductPost(post, collectionId),
                );
                dispatch(setCollectionsRecords(...response.collections.records.collections));
                dispatch(setCategoryRecords(response.post.records.categories));
                dispatch(setPostRecords(...response.post.records.posts));
                forEach(response.collections.collections, (id) => {
                    dispatch(
                        addPostToBookmarkCollections({
                            postId: post.id,
                            namespace: `${COLLECTIONS_NAMESPACE_PREFIX}${id}`,
                        }),
                    );
                });
            } catch (err) {
                dispatch(showNotificationAsync('Не удалось создать пост'));
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dispatch],
    );

    return (
        <AddPostDrawer
            collectionId={collectionId}
            handleClose={onNavigateBack}
            searchProduct={searchProduct}
            productLoading={productLoading}
            productLoadingError={productLoadingError}
            newPost={newPost}
            savePostToCollection={savePostToCollection}
        />
    );
};
